try {
    const Form = require('./form')
    const View = require('./view')
    const ExtensionService = require('live/services/extension')

    const pwda = {
        name: 'PWDA',
        type: 'liverig-pwda',
        origin: 'Plugin PWDA',
        roles: ['output'],
        icon: '/content/plugin-pwda/pwda.png',
        ui: {
            form: Form,
            view: View
        }
    }

    ExtensionService.register(pwda)
} catch (e) {
    console.error(e)
}
